module.exports = __webpack_public_path__ + "static/img/banner3.a297105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_activitycenter/banner3.png
// module id = 2Ygv
// module chunks = 1